import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link, useNavigate } from 'react-router-dom'

// constants
import * as constants from '../../globals/constants'

// styles
import colors from '../../styles/colors'

// images
import SignOutSelectImg from '../../assets/image/sidebar/ic-select-signout.svg'
import SignOutImg from '../../assets/image/sidebar/ic-unselect-signout.svg'

// const FOOTER_MENU_ITEM_N = [
//   {
//     name: 'FAQ',
//     id: 1,
//     path: '/useguide',
//     subMenu: null,
//   },
// ]

function Footer({ hiddenYn, hideSidebar, onClickSignOut }) {
  const navigate = useNavigate()
  const [isHover, setIsHover] = useState(false)

  const [agentYN, setAgentYN] = useState()

  //agent 사용여부
  useEffect(() => {
    const manageType = JSON.parse(localStorage.getItem('user'))?.manageType

    if (manageType == '5') {
      setAgentYN(true)
    } else {
      setAgentYN(false)
    }
  }, [])

  const FOOTER_MENU_ITEM = [
    {
      name: 'FAQ',
      id: 1,
      path: agentYN ? '/usePos' : '/useFaq',
      subMenu: null,
    },
    {
      name: 'POS용 주문접수 프로그램',
      id: 2,
      path: '/noticeList',
      subMenu: null,
    },
    {
      name: '보안패치 다운로드',
      id: 3,
      path: '/noticeList',
      subMenu: null,
    },
  ]

  const signOut = (e) => {
    e.preventDefault()
    hideSidebar()

    onClickSignOut()

    localStorage.removeItem('user')
    localStorage.removeItem('isNewNotice')
    localStorage.removeItem('happyorderYn')
    localStorage.removeItem('closedDay')
    localStorage.removeItem('shopHoursStart')
    localStorage.removeItem('shopHoursEnd')
    localStorage.removeItem('sessionAlert')

    window.location.reload()

    setTimeout(() => {
      navigate('/signin', { replace: true })
    }, 500)
  }

  const getLastPath = (path) => {
    return path.substring(path.lastIndexOf('/') + 1)
  }

  const handleSingleMenu = (e, path, idx) => {
    e.preventDefault()

    hideSidebar()

    switch (idx) {
      case 0:
        navigate(path)
        break

      case 1:
        break

      default:
        break
    }
  }

  return (
    <>
      <DivideLine />
      <Container>
        {hiddenYn ? (
          FOOTER_MENU_ITEM.map((menu, idx) => (
            <SingleMenu
              to={menu.path}
              key={idx}
              isCurrent={
                getLastPath(menu.path) === getLastPath(window.location.pathname)
              }
              onClick={(e) => {
                if (idx === 0) {
                  handleSingleMenu(e, menu.path, idx)
                }
              }}
              href={
                idx === 1
                  ? constants.API.POS_DOWNLOAD
                  : idx === 2
                  ? constants.API.SECURITY_DOWNLOAD
                  : ''
              }
              download
            >
              {menu.name}
            </SingleMenu>
          ))
        ) : (
          <SingleMenu
            to={`${FOOTER_MENU_ITEM[0].path}`}
            isCurrent={
              getLastPath(`${FOOTER_MENU_ITEM[0].path}`) ===
              getLastPath(window.location.pathname)
            }
            onClick={(e) => {
              handleSingleMenu(e, `${FOOTER_MENU_ITEM[0].path}`, 0)
            }}
          >
            FAQ
          </SingleMenu>
        )}

        <SignOutWrapper
          onMouseOut={() => setIsHover(false)}
          onMouseOver={() => setIsHover(true)}
          onClick={signOut}
        >
          <img src={isHover ? SignOutSelectImg : SignOutImg} />
          <span>로그아웃</span>
        </SignOutWrapper>
      </Container>
    </>
  )
}

export default Footer

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 30px 37px;

  @media ${(props) => props.theme.tablet} {
    padding: 0 30px 30px;
  }
`

const SingleMenu = styled.a`
  display: flex;
  align-items: center;
  width: 100%;
  color: ${(props) => (props.isCurrent ? `${colors.mainG}` : `${colors.G4}`)};
  font-size: 13px;
  font-weight: 700;
  padding-left: 20px;
  margin-bottom: 18px;
  word-break: keep-all;
  .menuBr {
    line-height: 1.5;
  }

  &:hover {
    color: ${colors.mainG};
    cursor: pointer;
  }

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => (props.isCurrent ? `${colors.mainG}` : `${colors.BK}`)};
    margin-bottom: 23px;
  }
`

const SignOutWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  padding: 10px 0;
  margin-top: 22px;

  border-radius: 10px;
  background-color: ${colors.G3};

  span {
    font-size: 13px;
    color: ${colors.G4};
    margin-left: 4px;
    margin-bottom: 2px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  &:hover {
    cursor: pointer;
    background-color: ${colors.mainG};

    span {
      color: ${colors.W1};
    }
  }

  @media ${(props) => props.theme.tablet} {
    margin-top: 12px;
  }

  @media ${(props) => props.theme.mobile} {
    margin-top: 7px;
  }
`

const DivideLine = styled.div`
  height: 1px;
  margin: 23px 0 33px;
  background-color: ${colors.G3};

  @media ${(props) => props.theme.tablet} {
    height: 5px;
  }
`
